module.exports = __webpack_public_path__ + "img/foodlab-social-media.aa18ad7.jpg";